import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ServerService } from '../../service/server/server.service';
import { Params, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { UserVideoComponent } from '../../user/user-video/user-video.component';
import { MessageService } from '../../service/message/message.service';

@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.scss']
})
export class DeviceComponent implements OnInit, OnDestroy {
  //**********************************************************
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public user_id: number | undefined;
  public server: string = this.serverService.get_server();
  public server_main: string = this.serverService.get_server_main();
  public site: string = this.serverService.get_site();;
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public dir: any = JSON.parse(<any>localStorage.getItem('dir'));
  public loading = false;
  public subscription: Subscription;
  public type_task: number | undefined;
  public confirm_delete: boolean | undefined;
  public count_total: number = 1;
  public page_number_first: number | undefined; public page_number_second: number | undefined; public page: number = 1;
  public code: any;
  public show_excel: boolean = false;
  public export_code: number | undefined;
  public type: number | undefined; public type_search: number | undefined;
  @ViewChild('myModal', { static: true }) myModal: any;
  @ViewChild('myModalSearch', { static: true }) myModalSearch: any;
  public pattern_title_with_persian: any;
  public logo_bin: boolean = false;
  public logo_info: any;
  public device_logo: string = this.serverService.get_default_image();
  //******************************************************************************
  public list_record: any = [];
  public list_status: any = [];
  //******************************************************************************
  public id: number | undefined;
  public pre_status: boolean | undefined; public next_status: boolean | undefined; public new_status: boolean | undefined;
  public status_id: number | undefined; public status_id_search: number | undefined;
  public title: string | undefined; public title_search: string | undefined;
  public search_all: string | undefined;
  //************
  public selected_record: any = [];
  public select_all: boolean | undefined;
  public indeterminate: boolean = false;
  public checked: boolean = false;
  public level: number | undefined;
  public creator: number | undefined;
  public video: string | undefined;
  public expire: boolean | undefined;
  public access_service: number | undefined;
  public path_export: string | undefined;
  //***********
  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  public dataSource: any | undefined;
  public displayedColumns = ['row', 'title', 'default', 'sort', 'status', 'id', 'operation'];
  //*************
  public form1_group: FormGroup | any;
  public form1_search_group: FormGroup | any;
  //************** */
  constructor(
    public serverService: ServerService
    , public ngxSmartModalService: NgxSmartModalService
    , public router: Router
    , public activatedRoute: ActivatedRoute
    , public messageService: MessageService
    , public matSnackBar: MatSnackBar
    , public dialog: MatDialog) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.code = params['id'];
      }
    )
    this.serverService.status1(2);
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.create_form1();
    this.create_search_form1();
    this.recieve_status();
    this.check_access(4, 1, 0, 1, 1);
    //**************
  }//end ngOnInit

  create_form1() {
    this.form1_group = new FormGroup({
      'title': new FormControl(null, [Validators.required]),
      'sort': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'status_id': new FormControl(null, [Validators.required, Validators.pattern('[0-9]{1,}')])
    })
  }

  create_search_form1() {
    this.form1_search_group = new FormGroup({
      'title_search': new FormControl(null),
      'status_id_search': new FormControl(null)
    })
  }
  //****************************************************************************
  check_access(type_task: any, page: number, id: any, excel: number, loading: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (type_task == 1 || type_task == 2)) {
      return false;
    }
    if (loading == 1) this.loading = true;
    var obj = {
      'address': 6,
      'type': 'user',
      'user_id': this.user_id,
      'id': this.code,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.access_service = res['result'][0].count;
          this.path_export = res['path_export'];
          this.check_access2(type_task, page, id, excel, loading, res['result'][0].count);
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }

  check_access2(type_task: any, page: number, id: any, excel: number, loading: number, access_service: number): any {
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', { 'address': 6, user_id: this.creator, id: this.code }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          this.title = res['result'][0].title;
          this.video = res['result'][0].video;
          this.expire = res['expire'];
          this.loading = false;
          if (type_task == 1) {
            if (this.expire == true) {
              this.message(true, this.messageService.expire(), 1, this.messageService.close());
              return false;
            } else {
              this.insert();
            }
          }
          if (type_task == 2) { this.update(); }
          if (type_task == 3) {
            var selected;
            if (typeof id == 'object') {
              selected = this.get_select_records(-1);
            } else {
              var selected = id;
            }
            this.delete(selected);
          }
          if (type_task == 4) { this.load_data(page, excel, loading, -1); }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }

  load_data(page: number, excel: number, loading: number, changedRows: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) {
      this.loading = true;
    }
    if (page == 1) { this.page = 1; }
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 20); }
    if (page == 3) { this.page = this.page - 1; }
    var obj = {
      'address': 1645
      , "page": this.page
      , "lang": this.lang
      , 'type': this.type
      , 'export_excel': excel
      , 'user_id': this.user_id
      , 'title': this.form1_search_group.value.title_search
      , 'status_id': this.form1_search_group.value.status_id_search
      , 'search_all': this.search_all
      , 'creator': this.creator
      , 'changedRows': changedRows
      , 'path_export': this.path_export
    }

    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (excel == 1) {
            if (changedRows == -1) this.list_record = [];
            if (changedRows > 0 || changedRows == -1) {
              for (var i = 0; i < res['num']; i++) {
                this.list_record.push(res['result'][i]);
              }//end for
            }
            this.dataSource = new MatTableDataSource(this.list_record);
            this.count_total = res['count'];
            this.pages(0);
            this.myModal.close();
            this.myModalSearch.close();
          }
          else if (excel == 2) {
            this.export_excel(res['export_code']);
          }
          this.serverService.change_window_resize(2, '', 0);
          this.serverService.send_services_id(this.code);
          this.serverService.send_reset({});
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data

  pages(count: number) {
    this.count_total = this.count_total + count;
    this.page_number_first = this.page * 20 - 19;
    this.page_number_second = this.page * 20;
    if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
    else { this.pre_status = false; this.new_status = true; }
    if (this.list_record.length < 20 || (this.page * 20 >= this.count_total)) {
      this.page_number_second = this.count_total;
      this.next_status = true;
    }//end if
    else { this.next_status = false; }
  }

  export_excel(code: number) {
    if (code > 0) {
      var x = <any>document.getElementById("excel");
      x.href = this.site + "/export/" + code + ".xlsx";
      x.click();
    }
  }

  open_video() {
    this.dialog.open(UserVideoComponent, {
      width: '45rem',
      height: 'auto',
      data: { id: this.code }
    })
  }
  //***************************************************************************
  change_task(type: number, id: number, title: string, status_id: number, sort: string) {
    this.type_task = type;
    this.show_excel = false;
    this.id = id;
    if (type == 1) {
      this.form1_group.patchValue({
        'title': "",
        'sort': "",
        'status_id': 1,
      });
      this.logo_info = {
        site: "",
        logo: ""
      };
      this.device_logo = this.serverService.get_default_image();
      this.type = 1;
      this.myModal.open();
    }//end if
    if (type == 2) {
      this.form1_group.patchValue({
        'title': title,
        'sort': sort,
        'status_id': status_id
      });
      this.get_logo(id);
      this.myModal.open();
    }//end else
    if (type == 3) {
      this.type = 3;
      this.myModalSearch.open();
    }
  }//end change_task

  get_bg(id: number) {
    this.id = id;
  }

  get_logo(id: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1849, id: id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            if (res['result'][0].wharehouse_device_site_logo) {
              this.device_logo = res['result'][0].wharehouse_device_site_logo + "/" + res['result'][0].wharehouse_device_logo;
              this.logo_info = {
                site: res['result'][0].wharehouse_device_site_logo,
                path: res['result'][0].wharehouse_device_logo,
              }
              this.logo_bin = true;
            }
            else {
              this.device_logo = this.serverService.get_default_image();
              this.logo_bin = false;
            }

          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  //***************************************************************************
  insert() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var obj = {
      'address': 1646
      , "user_id": this.user_id
      , 'status_id': this.form1_group.value.status_id
      , 'title': this.form1_group.value.title
      , 'sort': this.form1_group.value.sort
      , 'creator': this.creator
      , 'logo_info': this.logo_info
      , 'lang': this.lang
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.list_record.unshift(res['result'][0]);
          this.pages(1);
          if (this.count_total > 20) {
            this.list_record.pop();
            this.next_status = false;
          }//end if
          this.dataSource = new MatTableDataSource(this.list_record);
          this.myModal.close();
          this.id = res['result'][0].wharehouse_device_id;
          this.serverService.send_device();
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());
        }
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }//end insert
  //********************************************************************************
  update() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var obj = {
      'address': 1647, "user_id": this.user_id
      , 'title': this.form1_group.value.title
      , 'sort': this.form1_group.value.sort
      , 'status_id': this.form1_group.value.status_id
      , 'logo_info': this.logo_info
      , 'creator': this.creator
      , 'id': this.id
      , 'lang': this.lang
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          for (var i = 0; i < this.list_record.length; i++) {
            if (this.list_record[i].wharehouse_device_id == this.id) {
              this.list_record[i].wharehouse_device_title = res['result'][0].wharehouse_device_title;
              this.list_record[i].wharehouse_device_logo = res['result'][0].wharehouse_device_logo;
              this.list_record[i].wharehouse_device_site_logo = res['result'][0].wharehouse_device_site_logo;
              this.list_record[i].status_id = res['result'][0].status_id;
              this.list_record[i].status_title = res['result'][0].status_title;
            }//end if
          }//end for
          this.dataSource = new MatTableDataSource(this.list_record);
          this.myModal.close();
          this.serverService.send_device();
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());
        }
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }//end insert
  //********************************************************************************
  delete(id: any) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var confirm_delete;
    confirm_delete = window.confirm(this.messageService.message_delete_accept());
    this.loading = false;
    if (confirm_delete == true) {
      this.loading = true;
      var address;
      if (typeof id == 'object') { address = 1649; } else { address = 1648; }
      var obj = {
        'address': address, "user_id": this.user_id, 'id': id
      }
      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res: any) => {
          if (res['status'] == 1) {
            if (typeof id == 'number') {
              this.list_record.splice(this.list_record.findIndex((index: any) => index.wharehouse_device_id == id), 1);
            }
            else {
              for (var i = 0; i < res['result_record'].length; i++) {
                this.list_record.splice(this.list_record.findIndex((index: any) => index.wharehouse_device_id == res['result_record'][i].wharehouse_device_id), 1);
              }
            };
            this.serverService.send_device();
            this.pages(-res['result'].changedRows);
            this.load_data(this.page, 1, 1, res['result'].changedRows);
            this.message(true, this.messageService.message_delete(), 1, this.messageService.close());
          }//end if
          else if (res['status'] == 4) {
            this.message(true, this.messageService.message_delete_alarm(), 1, this.messageService.close());
          }
          else {
            this.message(true, this.messageService.message_error(), 1, this.serverService.message_action());
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true      
  }//end delete 

  get_select(event: boolean): any {
    this.selected_record = [];
    this.get_select_all(event).then((res: any) => {
      if (res == this.list_record.length - 1) this.get_select_records(-1);
    }).catch((err: any) => { console.log(err); });
  }

  get_select_all(event: boolean): any {
    var finish;
    var promise = new Promise<void>((resolve, reject) => {
      this.indeterminate = false;
      this.select_all = event;
      for (var i = 0; i < this.list_record.length; i++) {
        this.list_record[i].checked = this.select_all;
        finish = i;
      }
      this.dataSource.data = this.list_record;
      return resolve()
    });
    return Promise.resolve(finish);
  }

  get_select_records(index: number) {
    if (index >= 0) {
      this.list_record[index].checked = !this.list_record[index].checked;
    }
    this.selected_record = [];
    var selected_record_temp;
    selected_record_temp = <any>document.getElementsByName('selete_records[]');
    for (var i = 0; i < selected_record_temp.length; i++) {
      if (selected_record_temp[i].checked == true) {
        this.selected_record.push(selected_record_temp[i].value);
      }
    }
    this.selected_record = this.selected_record.map((items: any) => {
      return parseInt(items);
    });
    if (this.selected_record.length != this.list_record.length && this.selected_record.length > 0) {
      this.indeterminate = true;
    } else {
      this.indeterminate = false;
    }
    return this.selected_record;
  }

  change_default(j: number, value: number, id: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1969, user_id: this.user_id, 'status_default': value, 'id': id, creator: this.creator }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (value == 0) {
            for (var i = 0; i < this.list_record.length; i++) {
              if (this.list_record[i].wharehouse_device_default == 1) {
                this.list_record[i].wharehouse_device_default = 0;
              }
            }
          }
          this.list_record[j].wharehouse_device_default = res['result'][0].wharehouse_device_default;
          this.dataSource = new MatTableDataSource(this.list_record);
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.erorr_in_save_default(this.lang), 1, this.messageService.close());
        }
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }

  //****************************************************************************** */
  change_logo(event: any) {
    var selectedFile = <File>event.target.files[0];
    var fd = new FormData();
    fd.append("image", selectedFile, selectedFile.name);
    this.serverService.post_address_file(this.server, "uploadImage", fd).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          //this.uploadedAvaterProgess = (event.loaded / event.total) * 100;
        }
        else if (event.type === HttpEventType.Response) {
          var a = <any>event.body;
          this.device_logo = this.serverService.get_site() + "/" + this.serverService.get_path_upload_image() + a.result.filename;
          this.logo_bin = true;
          this.logo_info = {
            'site': this.serverService.get_site(),
            'path': this.serverService.get_path_upload_image() + a.result.filename
          }
        }
      }
    )
  }

  delete_logo() {
    this.device_logo = this.serverService.get_default_image();
    this.logo_bin = false;
    this.logo_info = {
      path: '',
      site: ''
    }
  }
  //*******************************************************************************
  recieve_status() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1, lang: this.lang }).subscribe(
      (res: any) => {
        this.list_status = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_status.push(res['result'][i]);
          }//end for
          this.message(false, "", 2, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }//end recieve_status
  //*******************************************************************************
  change_resize() {
    this.serverService.change_window_resize(1, '', 0);
  }//end change_resize
  //*******************************************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 3000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 


  ModalClose() {
    this.message(false, "", 2, this.messageService.close());
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}